<div id="wrapper">

  <div class="page-title">
    <div class="tf-tsparticles">
      <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
    </div>
    <div class="tf-container">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <h1 class="title">Account Activation</h1>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="spacing-big"></div>

<div class="tf-container">
  <div class="row">
    <div class="col">
      <div class="center">

        <h2>Your account is successful activated!</h2>
        <div class="spacing-minor"></div>
        <button class="tf-btn style-1" (click)="redirectNow()">Return to home</button>

      </div>
    </div>
  </div>
</div>

<div class="spacing-big"></div>